import { createFileRoute, redirect } from '@tanstack/react-router'

export const redirectLegacyCondolencesSettings = ({ params }: { params: { orgId: number } }) => {
  throw redirect({
    to: '/$orgId/settings/integrations/condolences',
    params: { orgId: params.orgId },
    replace: true,
  })
}

export const Route = createFileRoute('/_authenticated/$orgId/settings/condolences/')({
  loader: redirectLegacyCondolencesSettings,
})
